import React from "react";

import FlightIcon from "@mui/icons-material/Flight";
import HotelIcon from "@mui/icons-material/Hotel";
import StarPurple500Icon from "@mui/icons-material/StarPurple500";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

import { AlertTypeEnum } from "@/constants";
import usePlatform from "@/hooks/usePlatform";

const AlertTab = (props: { value: AlertTypeEnum; onChange: (value: AlertTypeEnum) => void }) => {
  const { isPc } = usePlatform();

  const handleChange = (event: React.MouseEvent<HTMLElement>, value: AlertTypeEnum) => {
    if (value) {
      props.onChange(value);
    }
  };

  return (
    <ToggleButtonGroup
      color="primary"
      value={props.value}
      exclusive
      onChange={handleChange}
      aria-label="Platform"
      size="small"
      sx={
        isPc
          ? {
              width: "560px",
            }
          : {
              width: "100%",
              display: "flex",
            }
      }
    >
      <ToggleButton
        value={AlertTypeEnum.Flight}
        sx={{
          borderTopLeftRadius: "30px",
          borderBottomLeftRadius: "30px",
          flex: 1,
        }}
      >
        <div className="flex items-center px-[10px]">
          <FlightIcon sx={{ fontSize: "18px" }} className="mr-[10px] rotate-[45deg]" />
          <span>Flights</span>
        </div>
      </ToggleButton>
      <ToggleButton
        value={AlertTypeEnum.Panorama}
        sx={{
          flex: 1,
        }}
      >
        <div className="flex items-center px-[10px]">
          <StarPurple500Icon sx={{ fontSize: "18px" }} className="mr-[10px]" />
          Panorama
        </div>
      </ToggleButton>
      <ToggleButton
        value={AlertTypeEnum.Hotel}
        sx={{
          borderTopRightRadius: "30px",
          borderBottomRightRadius: "30px",
          flex: 1,
        }}
      >
        <div className="flex items-center px-[10px]">
          <HotelIcon sx={{ fontSize: "18px" }} className="mr-[10px]" />
          Hotels
        </div>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default AlertTab;
